export const DISCOUNT_RATES = {
  subscribers: 10,
  friendsAndFamily: 15,
  sales: 25
};

/**
 * Returns the highest applicable discount percentage for a product given the user's eligibility.
 * Pass isRoyalSubscriber=false and isFriendsAndFamily=false to get discount for a non-qualified user.
 */
export function getProductDiscountPct(product, isRoyalSubscriber = false, isFriendsAndFamily = false) {
  let max = 0;
  const e = product?.discountEligibility || {};
  if (e.subscribers && (isRoyalSubscriber || isFriendsAndFamily)) max = Math.max(max, DISCOUNT_RATES.subscribers);
  if (e.friendsAndFamily && isFriendsAndFamily) max = Math.max(max, DISCOUNT_RATES.friendsAndFamily);
  if (e.sales) max = Math.max(max, DISCOUNT_RATES.sales);
  return max;
}

/**
 * Returns the badge info for product listing cards (not user-specific).
 * Only shows publicly visible discount types (SALE, MEMBERS).
 */
export function getProductListingBadge(product) {
  const e = product?.discountEligibility || {};
  if (e.sales) return { label: 'SALE', type: 'sale' };
  if (e.subscribers) return { label: 'MEMBERS', type: 'members' };
  return null;
}

/**
 * Calculates the discounted price for a given original price and discount percentage.
 */
export function applyDiscount(price, discountPct) {
  if (!discountPct) return price;
  return Math.round(price * (1 - discountPct / 100) * 100) / 100;
}
